import {numberFormatter} from "../../gridFormatters";

export const operatingCostDefs = [
    {
        "field": "deviceType",
        "headerName": "Device Type",
        "hide": false,
        "editable": false,
        "minWidth": 100
    },
    {
        "field": "powerCost",
        "headerName": "Power Cost ($/mo)",
        "cellEditor": "agTextCellEditor",
        "hide": false,
        "editable": true,
        cellRenderer: numberFormatter,
        "minWidth": 100
    },
    {
        "field": "floorSpaceCost",
        "headerName": "Floor Space Cost ($/mo)",
        "cellEditor": "agTextCellEditor",
        "hide": false,
        "editable": true,
        cellRenderer: numberFormatter,
        "minWidth": 100
    },
    {
        "field": "personnelCost",
        "headerName": "Personnel Cost ($/mo)",
        "cellEditor": "agTextCellEditor",
        "hide": false,
        "editable": true,
        cellRenderer: numberFormatter,
        "minWidth": 100
    },
];
